import React from 'react'
import Link from '../atoms/Link'
import OneColWrapper from '../technical/OneColWrapper'
import Headline from '../atoms/Headline'

const ChecklistBlock = ({ block }) => {
  return (
    <OneColWrapper block={block} className="checklist-block">
      <div>
        <Headline
          kicker={block.kicker}
          headline={block.headline}
          headline_level="h4"
          subheadline={block.subheadline}
        />
        <ul className="checklist-block-checklist">
          {block.list?.length > 0 &&
            block.list.map((item, index) => (
              <li key={index}>
                {item.title}
                <br />
                <span className="text-muted">{item.subtitle}</span>
              </li>
            ))}
        </ul>
        {block.download_link?.filename?.length > 0 && (
          <Link link={block.download_link} className="btn btn-primary">
            {block.download_text}
          </Link>
        )}
      </div>
    </OneColWrapper>
  )
}

export default ChecklistBlock
